module.exports = {
    ignoreDependency: /^\!.+/,
    errorDependency: /^\*/,
    errorSymbol: '*'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/kgo/symbols.js
 ** module id = 212
 ** module chunks = 1
 **/